<script setup lang="ts">
import { useField } from 'vee-validate';
import type { FormTextareaProps } from './form-textarea';
import FormFieldError from './FormFieldError.vue';
import { validateRequired } from '../validation-rules';
import { makeValidateTextareaMaxLineLength } from './form-textarea.validation';
import type { ValidatorRule } from '../validation-rules';
import TTextArea from '../../Input/TTextArea.vue';

const props = withDefaults(defineProps<FormTextareaProps>(), {
  rows: 3,
});

const rules: ValidatorRule[] = [];

if (props.required) {
  rules.push(validateRequired);
}

if (props.maxLineLength !== undefined) {
  rules.push(
    makeValidateTextareaMaxLineLength(
      props.maxLineLength,
      props.maxLineLengthErrorMessage,
    ),
  );
}

if (props.validators?.length) {
  rules.push(...props.validators);
}

const field = useField<string>(props.name, rules, {
  validateOnValueUpdate: true,
});
</script>

<template>
  <div class="relative flex w-full flex-col">
    <TTextArea
      :value="field.value.value ?? ''"
      :rows="rows"
      :placeholder="placeholder"
      :disabled="disabled"
      emit-change-on-input
      @change="field.handleChange($event)"
    />
    <FormFieldError
      v-if="field.errorMessage.value"
      :message="field.errorMessage.value"
    />
  </div>
</template>
